import React from 'react';
import cs from 'classnames';

import css from './index.css';

export const MenuList = (props) => (
  <div className={cs(css.wrap, props.className, 'qa-menu')} data-qa={props['data-qa'] || 'menu-list'}>
    {React.Children.map(props.children, i => i && React.cloneElement(i, {'multi': props.multi}))}
  </div>
);

export const MenuListItem = (props) => {
  const mods = {
    [css.selected]: props.selected,
    [css.disabled]: props.disabled,
    [css.cutText]: props.cutText,
  };

  const greyMods = {
    [css.selectedGrey]: props.selected,
    [css.disabled]: props.disabled,
    [css.cutText]: props.cutText,
  };

  const prefix = props['data-qa'];
  const dataQa = (postfix) => {
    if (!prefix) {
      return null;
    }

    if (!postfix) {
      return prefix;
    }

    return `${prefix}-${postfix}`;
  };


  const className = props.greyStyle ? cs(css.item, greyMods, props.className) : cs(css.item, mods, props.className);

  if (props.href) {
    return (
      <a
        className={className}
        href={props.href}
        target='_blank'
        data-qa={dataQa()}
      >
        {props.title}
      </a>
    );
  }

  let selected = null;
  if (props.multi) {
    if (props.greyStyle) {
      selected = (<div className={cs(css.greyCheckbox, greyMods)} data-qa={dataQa('checkbox')}/>);
    } else {
      selected = (<div className={cs(css.checkbox, mods)} data-qa={dataQa('checkbox')}/>);
    }
  }

  let info = null;
  if (props.info) {
    info = (<div className={cs(css.info)}>{props.info}</div>)
  }

  return (
    <div
      className={className}
      onClick={props.fn}
      onMouseDown={props.onMouseDown}
      data-value={props.data}
      id={props.id}
      data-num={props.num}
      data-name={props.name}
      data-qa={dataQa()}
      data-qa-selected={props.selected ? true : null}
    >
      {selected}
      {props.title}
      {info}
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/components/common/MenuList/index.js